import styled from "styled-components";

export const SSelectProjectStepHeaderSwitch = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-01);
  margin-left: auto;
`;
